export const loadFormClassName = 'w-full flex flex-col gap-y-[10px] py-[10px]';
export const labelClassName = 'font-bold text-[15px]';

export const titleTagFormType = 'font-bold text-[18px]';

export const fieldLabelClassName = 'text-0color font-[400] whitespace-nowrap text-[15px]';
export const fieldBlockClassName = 'flex items-center justify-between';
